<template>
  <div class="form-group">
    <label v-if="label" :for="name">{{ label }}</label>
    <div :class="{ 'input-group': $slots.default, field_with_errors: error }">
      <input
        :id="name"
        :disabled="disabled"
        :value="value"
        :required="required"
        :type="type"
        :placeholder="placeholder"
        :name="name"
        :min="min"
        :step="step"
        :size="maxlength"
        :maxlength="maxlength"
        @input="changeValue"
        @focus="$emit('focus')"
        @blur="$emit('blur')"
        class="form-control"
      />
      <div v-if="$slots.default" class="input-group-append">
        <slot></slot>
      </div>
    </div>
    <div v-if="error" class="formError">{{ error }}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "FormInput",
  props: {
    value: {
      type: [String, Number],
      default: "",
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxlength: {
      type: Number,
      default: undefined,
    },
    min: { type: Number, default: null },
    step: { type: Number, default: undefined },
  },
  computed: {
    ...mapGetters({ errorFor: "validations/errorFor" }),
    error() {
      return this.errorFor(this.name)?.join(", ");
    },
  },
  methods: {
    changeValue(e) {
      this.$emit("input", e.target.value);
    },
  },
};
</script>
